function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { arrayOf, bool, elementType, exact, func, number, shape, string, object, oneOf, oneOfType } from 'prop-types';
import clsx from 'clsx';
import { alpha, styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import assetResolver, { assetKeys } from 'mosaic-assets-resolver';
import Slide from '@mui/material/Slide';
import Modal from '@mui/material/Modal';
import SovosTypography from '../sovos-typography';
import SovosDialog from '../sovos-dialog';
import SovosDialogActions from '../sovos-dialog-actions';
import SovosDialogContent from '../sovos-dialog-content';
import SovosDialogTitle from '../sovos-dialog-title';
import SovosButton from '../sovos-button';
import NavigationLinks from './components/navigation-links/NavigationLinks';
import SovosAccountSwitcher from '../sovos-account-switcher';
import ProductMenu from './components/product-menu/ProductMenu';
import NavigationFooter from './components/navigation-footer/NavigationFooter';
import { collapsedWidthFactor, navigationWidthFactor } from '../themes/sovos-sizes';
import { useResize } from '../hooks';
import { ResizeContext } from '../internals/utils';
import NavigationLinksMinimal from './components/navigation-links/NavigationLinksMinimal';
import HEADER from './constants/header';
import { isLinkSelected } from './components/navigation-links/navigationLinksUtils';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
var Root = styled('nav')(function (_ref) {
  var _overrides$sovosNavig, _overrides$sovosNavig2, _overrides$sovosNavig3, _overrides$sovosNavig4, _overrides$sovosNavig5, _overrides$sovosNavig6, _overrides$sovosNavig7, _overrides$sovosNavig8;
  var _ref$theme = _ref.theme,
    overrides = _ref$theme.overrides,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing,
    transitions = _ref$theme.transitions,
    typography = _ref$theme.typography;
  var navigationWidth = spacing(navigationWidthFactor);
  var collapsedWidth = spacing(collapsedWidthFactor);
  var collapsedSwitcherWidth = spacing(collapsedWidthFactor - 2);
  return {
    flex: "0 0 ".concat(navigationWidth),
    height: '100vh',
    outline: 'none',
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: "flex ".concat(transitions.duration.enteringScreen, "ms"),
    width: navigationWidth,
    // parent switches from flex-direction: row to column

    '&.sovosNavigation--minimal': {
      flex: "0 0 ".concat(collapsedWidth),
      width: collapsedWidth
    },
    '& .sovosNavigation__content': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      height: '100%',
      transition: "width ".concat(transitions.duration.leavingScreen, "ms"),
      width: navigationWidth
    },
    '&.sovosNavigation--minimal .sovosNavigation__content': {
      transition: "width ".concat(transitions.duration.enteringScreen, "ms"),
      width: collapsedWidth
    },
    '&.sovosNavigation--minimal .sovosAccountSwitcher': {
      marginTop: spacing(2)
    },
    '&:not(.sovosNavigation--minimal) .sovosNavigation__productSwitcher': {
      marginRight: spacing(1)
    },
    '& .SovosAccountSwitcher__buttonContents:not(.SovosAccountSwitcher__buttonContents--minimized)': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginTop: spacing(2),
      marginRight: spacing()
    },
    '&.sovosNavigation--minimal .sovosSwitcher__button': {
      margin: "0 ".concat(spacing()),
      minWidth: collapsedSwitcherWidth,
      width: collapsedSwitcherWidth
    },
    '& .sovosNavigation__header': {
      backgroundColor: (_overrides$sovosNavig = overrides === null || overrides === void 0 ? void 0 : (_overrides$sovosNavig2 = overrides.sovosNavigation) === null || _overrides$sovosNavig2 === void 0 ? void 0 : _overrides$sovosNavig2.headerBackground) !== null && _overrides$sovosNavig !== void 0 ? _overrides$sovosNavig : palette.primary.dark,
      padding: "".concat(spacing(3), " 0 ").concat(spacing(2), " 0")
    },
    '& .sovosNavigation__logoAndProductContainer': {
      alignItems: 'start',
      display: 'flex',
      justifyContent: 'center',
      minHeight: spacing(5.5)
    },
    '& .sovosNavigation__logoAndProduct': {
      display: 'block',
      flex: "1 0 ".concat(spacing(navigationWidthFactor - 8.5)),
      marginLeft: spacing(2.5)
    },
    '&.sovosNavigation--minimal .sovosNavigation__logoAndProduct': {
      display: 'none'
    },
    '& img.sovosNavigation__logo': {
      display: 'block',
      height: spacing(2.75)
    },
    '& .sovosNavigation__productName': _objectSpread(_objectSpread({}, typography.button), {}, {
      color: (_overrides$sovosNavig3 = overrides === null || overrides === void 0 ? void 0 : (_overrides$sovosNavig4 = overrides.sovosNavigation) === null || _overrides$sovosNavig4 === void 0 ? void 0 : _overrides$sovosNavig4.productNameColor) !== null && _overrides$sovosNavig3 !== void 0 ? _overrides$sovosNavig3 : alpha(palette.primary.light, 0.75),
      margin: "".concat(spacing(0.25), " ").concat(spacing(), " 0 0")
    }),
    '& .sovosNavigation__linksContainer': {
      background: "linear-gradient(".concat((_overrides$sovosNavig5 = overrides === null || overrides === void 0 ? void 0 : (_overrides$sovosNavig6 = overrides.sovosNavigation) === null || _overrides$sovosNavig6 === void 0 ? void 0 : _overrides$sovosNavig6.gradientTop) !== null && _overrides$sovosNavig5 !== void 0 ? _overrides$sovosNavig5 : palette.primary.dark, ", ").concat((_overrides$sovosNavig7 = overrides === null || overrides === void 0 ? void 0 : (_overrides$sovosNavig8 = overrides.sovosNavigation) === null || _overrides$sovosNavig8 === void 0 ? void 0 : _overrides$sovosNavig8.gradientBottom) !== null && _overrides$sovosNavig7 !== void 0 ? _overrides$sovosNavig7 : palette.primary.dark, ")"),
      flex: 'auto',
      paddingTop: spacing(),
      overflowX: 'hidden',
      overflowY: 'auto'
    }
  };
});
export var navigationClassName = 'sovosNavigation';

/**
 * In most applications this component will be rendered by
 * `SovosGlobalLayout`. It can be used directly for custom situations that
 * do not use the global layout. The design is responsive with automatic collapsing.
 */
var SovosNavigation = function SovosNavigation(_ref2) {
  var _SovosAccountSwitcher, _div;
  var accounts = _ref2.accounts,
    accountsAreLoading = _ref2.accountsAreLoading,
    accountSwitcherLabels = _ref2.accountSwitcherLabels,
    className = _ref2.className,
    dataTestId = _ref2['data-testid'],
    didAccountChange = _ref2.didAccountChange,
    FooterProps = _ref2.FooterProps,
    initialSelectedLink = _ref2.initialSelectedLink,
    links = _ref2.links,
    minimumAccountSearchCharacters = _ref2.minimumAccountSearchCharacters,
    onAccountSearch = _ref2.onAccountSearch,
    onExpandAccount = _ref2.onExpandAccount,
    onSelectProduct = _ref2.onSelectProduct,
    product = _ref2.product,
    products = _ref2.products,
    productSwitcherLabel = _ref2.productSwitcherLabel,
    saveNavCollapsed = _ref2.saveNavCollapsed,
    selectedAccount = _ref2.selectedAccount,
    selectedLinkProp = _ref2.selectedLink,
    setAccount = _ref2.setAccount,
    showSingleAccount = _ref2.showSingleAccount;
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  var theme = useTheme();
  var _useState = useState(!!(saveNavCollapsed && sessionStorage.getItem('navIsCollapsed') === 'true')),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var isBreakpointSmall = useMediaQuery(theme.breakpoints.down('md'));
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isModal = _useState4[0],
    setIsModal = _useState4[1];
  var isMinimal = !isModal && (isBreakpointSmall || isCollapsed);
  var _useState5 = useState(initialSelectedLink),
    _useState6 = _slicedToArray(_useState5, 2),
    linkState = _useState6[0],
    setLinkState = _useState6[1];
  var selectedLink = selectedLinkProp || linkState;
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    confirmNavigationLinks = _useState8[0],
    setConfirmNavigationLinks = _useState8[1];
  var contentRef = useRef(null);
  var _useResize = useResize(contentRef),
    _useResize2 = _slicedToArray(_useResize, 1),
    contentRect = _useResize2[0];
  useEffect(function () {
    if (!isBreakpointSmall) {
      setIsModal(false);
    }
  }, [isBreakpointSmall]);
  var handleModalClose = function handleModalClose() {
    if (isModal) setIsModal(false);
  };
  var handleCollapseClick = function handleCollapseClick() {
    if (isMinimal && isBreakpointSmall) {
      setIsModal(true);
      return;
    }
    if (isModal) {
      setIsModal(false);
      return;
    }

    // collapsed nav session storage
    if (saveNavCollapsed) {
      var navIsCollapsed = sessionStorage.getItem('navIsCollapsed');
      if (navIsCollapsed === 'false') {
        sessionStorage.setItem('navIsCollapsed', 'true');
      } else {
        sessionStorage.setItem('navIsCollapsed', 'false');
      }
    }
    setIsCollapsed(function (prevState) {
      return !prevState;
    });
  };
  var selectLink = function selectLink(link) {
    var action = link.action,
      id = link.id,
      label = link.label;
    action();
    if (!selectedLinkProp) {
      setLinkState(id !== null && id !== void 0 ? id : label);
    }
  };
  var handleSelectLink = function handleSelectLink(link) {
    handleModalClose();
    if (!selectedLinkProp && isLinkSelected(link, linkState)) {
      return;
    }
    var currentLink = links.find(function (l) {
      return isLinkSelected(l, selectedLink) || l.nestedLinks && l.nestedLinks.find(function (nl) {
        return isLinkSelected(nl, selectedLink);
      });
    });
    if (currentLink !== null && currentLink !== void 0 && currentLink.confirmNavigationDialogProps && currentLink !== null && currentLink !== void 0 && currentLink.confirmNavigationDialogProps.shouldShowDialog()) {
      setConfirmNavigationLinks([currentLink, link]);
    } else {
      selectLink(link);
    }
  };
  var handleSetAccount = function handleSetAccount(newContext) {
    handleModalClose();
    setAccount(newContext);
  };
  var productMenuProps = useMemo(function () {
    var handleSelectProduct = function handleSelectProduct(event) {
      if (isModal) setIsModal(false);
      if (typeof onSelectProduct === 'function') onSelectProduct(event);
    };
    var calculatedProduct = _typeof(product) === 'object' ? product : {
      id: product,
      name: product
    };
    return {
      label: productSwitcherLabel || t('navigation.productSwitcherLabel'),
      selectedProduct: calculatedProduct,
      products: Array.isArray(products) && products.length ? products : [calculatedProduct],
      onSelectProduct: handleSelectProduct
    };
  }, [isModal, product, products, productSwitcherLabel, t, onSelectProduct]);
  var showContextSwitcher = showSingleAccount || selectedAccount && (accounts && accounts.length > 0 && (accounts.length > 1 || accounts[0].nestedAccounts && accounts[0].nestedAccounts.length > 0) || onAccountSearch);
  var renderConfirmNavigationDialog = function renderConfirmNavigationDialog() {
    if (!confirmNavigationLinks) {
      return undefined;
    }
    var _confirmNavigationLin = _slicedToArray(confirmNavigationLinks, 2),
      currentLink = _confirmNavigationLin[0],
      targetLink = _confirmNavigationLin[1];
    var _currentLink$confirmN = currentLink.confirmNavigationDialogProps,
      cancelButtonText = _currentLink$confirmN.cancelButtonText,
      continueButtonText = _currentLink$confirmN.continueButtonText,
      content = _currentLink$confirmN.content,
      title = _currentLink$confirmN.title;
    return /*#__PURE__*/React.createElement(SovosDialog, {
      onClose: function onClose() {
        return setConfirmNavigationLinks(undefined);
      },
      open: true,
      width: "small"
    }, /*#__PURE__*/React.createElement(SovosDialogTitle, null, title), /*#__PURE__*/React.createElement(SovosDialogContent, null, typeof content === 'function' ? content() : content), /*#__PURE__*/React.createElement(SovosDialogActions, null, /*#__PURE__*/React.createElement(SovosButton, {
      onClick: function onClick() {
        return setConfirmNavigationLinks(undefined);
      },
      variant: "text"
    }, cancelButtonText), /*#__PURE__*/React.createElement(SovosButton, {
      color: "error",
      onClick: function onClick() {
        setConfirmNavigationLinks(undefined);
        selectLink(targetLink);
      }
    }, continueButtonText)));
  };
  var Links = isMinimal && !isModal ? NavigationLinksMinimal : NavigationLinks;
  function getLogoSrc() {
    var _overrides$sovosNavig9, _overrides$sovosNavig10;
    var overrides = theme.overrides;
    // force the logo src to evaluate late so that we can ensure the asset
    // resolver has been configured
    return overrides !== null && overrides !== void 0 && (_overrides$sovosNavig9 = overrides.sovosNavigation) !== null && _overrides$sovosNavig9 !== void 0 && _overrides$sovosNavig9.logoUrl ? "".concat(overrides === null || overrides === void 0 ? void 0 : (_overrides$sovosNavig10 = overrides.sovosNavigation) === null || _overrides$sovosNavig10 === void 0 ? void 0 : _overrides$sovosNavig10.logoUrl) : "".concat(assetResolver.branding(assetKeys.branding.logoLight));
  }
  var renderNavigation = function renderNavigation() {
    var _theme$overrides, _theme$overrides$sovo;
    return /*#__PURE__*/React.createElement(Root, {
      "aria-label": "Main",
      className: clsx('sovosNavigation', className, navigationClassName, isMinimal && "".concat(navigationClassName, "--minimal")),
      "data-testid": dataTestId
    }, /*#__PURE__*/React.createElement("div", {
      className: "sovosNavigation__content",
      ref: contentRef
    }, /*#__PURE__*/React.createElement("header", {
      className: "sovosNavigation__header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sovosNavigation__logoAndProductContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sovosNavigation__logoAndProduct"
    }, /*#__PURE__*/React.createElement("img", {
      src: getLogoSrc(),
      alt: (theme === null || theme === void 0 ? void 0 : (_theme$overrides = theme.overrides) === null || _theme$overrides === void 0 ? void 0 : (_theme$overrides$sovo = _theme$overrides.sovosNavigation) === null || _theme$overrides$sovo === void 0 ? void 0 : _theme$overrides$sovo.logoAlt) || 'Sovos',
      className: "sovosNavigation__logo"
    }), /*#__PURE__*/React.createElement(SovosTypography, {
      className: "sovosNavigation__productName"
    }, productMenuProps.selectedProduct.name)), /*#__PURE__*/React.createElement(ProductMenu, productMenuProps)), showContextSwitcher && (_SovosAccountSwitcher || (_SovosAccountSwitcher = /*#__PURE__*/React.createElement(SovosAccountSwitcher, {
      accounts: accounts,
      didAccountChange: didAccountChange,
      isLoading: accountsAreLoading,
      isMinimal: isMinimal,
      labels: accountSwitcherLabels,
      minimumSearchCharacters: minimumAccountSearchCharacters,
      onExpandAccount: onExpandAccount,
      onSearch: onAccountSearch,
      selectedAccount: selectedAccount,
      setAccount: handleSetAccount
    })))), _div || (_div = /*#__PURE__*/React.createElement("div", {
      className: "sovosNavigation__linksContainer"
    }, /*#__PURE__*/React.createElement(Links, {
      key: selectedLink,
      links: links,
      onLinkClick: handleSelectLink,
      selectedLink: selectedLink
    }))), /*#__PURE__*/React.createElement(NavigationFooter, _extends({
      handleModalClose: handleModalClose,
      isCollapsed: isMinimal,
      onCollapseClicked: handleCollapseClick
    }, FooterProps))));
  };
  return /*#__PURE__*/React.createElement(ResizeContext.Provider, {
    value: contentRect
  }, isModal ? /*#__PURE__*/React.createElement(Modal, {
    open: isModal,
    onClose: handleModalClose
  }, /*#__PURE__*/React.createElement(Slide, {
    direction: "right",
    in: isModal,
    timeout: theme.transitions.duration.enteringScreen
  }, renderNavigation())) : renderNavigation(), renderConfirmNavigationDialog());
};
SovosNavigation.propTypes = {
  /**
   * Array of available context objects
   *
   * **Note**: does not render when length is 0 or 1, as there is nothing
   * to _switch_ to
   */
  accounts: arrayOf(shape({
    name: string.isRequired,
    taxYear: string,
    type: oneOf(['production', 'test', 'default']),
    nestedAccounts: arrayOf(object)
  })),
  /**
   * If `true`, `onAccountSearch` is loading results
   */
  accountsAreLoading: bool,
  /**
   * Labels for searching in account switcher
   */
  accountSwitcherLabels: exact({
    loading: string,
    noResults: string,
    searchTemplate: string
  }),
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * Custom context equality check
   */
  didAccountChange: func,
  /**
   * Properties for the sovos navigation footer child component
   */
  FooterProps: shape({
    labels: exact({
      collapseIcon: string,
      helpIcon: string,
      moreIcon: string,
      settingsIcon: string,
      userIcon: string
    }),
    onHelpClicked: func,
    showSettingsButton: bool,
    showHelpButton: bool,
    settingsMenuItems: arrayOf(shape({
      label: string,
      action: func
    })),
    userName: string.isRequired,
    userMenuItems: arrayOf(shape({
      label: string,
      action: func
    })).isRequired
  }),
  /**
   * Link selected on load. When specified, the component will manage the
   * link selection state.
   */
  initialSelectedLink: string,
  /**
   * Array of objects, each with:
   *
   * - `confirmationDialogProps`: object with
   *
   *   - `cancelButtonText`: string,
   *   - `continueButtonText`: string,
   *   - `content`: string or func, content of the dialog can be static or
   *       dynamically generated by a function
   *   - `shouldShowDialog`: func, if true, a dialog will be shown allowing the
   *       user to cancel or continue the navigation action
   *   - `title`: string,
   * - `id`: string or number
   * - `label`: string, content of the link
   * - `icon`: element, icon to display
   * - `action`: function, callback fired when the link is clicked
   * - `nestedLinks`: array, nested links
   * - `type`: 'content' or 'header', 'content is the default.
   *
   * `label` is always required. `icon` and either `action` OR
   * `nestedLinks` are required when `type` is not `header`
   *
   * `confirmationDialogProps` controls conditional navigation. The prop
   * object is optional but all values in the object are required. If
   * `confirmationDialogProps` is given and the `shouldShowDialog` function
   * returns true, the user will be given the option to cancel the navigation action
   */
  links: arrayOf(shape({
    action: function action(props) {
      var action = props.action,
        nestedLinks = props.nestedLinks,
        type = props.type;
      if (type === HEADER) {
        return null;
      }
      var baseError = '`SovosNavigation` received an invalid link: links should have either nestedLinks or an action function, but received';
      if (nestedLinks !== null && nestedLinks !== void 0 && nestedLinks.length) {
        if (action != null) {
          return new Error("".concat(baseError, " both."));
        }
      } else if (typeof action !== 'function') {
        return new Error("".concat(baseError, " neither."));
      }
      return null;
    },
    confirmNavigationDialogProps: shape({
      cancelButtonText: string.isRequired,
      continueButtonText: string.isRequired,
      content: oneOfType([func, string]).isRequired,
      shouldShowDialog: func.isRequired,
      title: string.isRequired
    }),
    disabled: bool,
    icon: elementType,
    id: oneOfType([string, number]),
    label: string.isRequired,
    nestedLinks: arrayOf(shape({
      action: func.isRequired,
      confirmNavigationDialogProps: shape({
        cancelButtonText: string.isRequired,
        continueButtonText: string.isRequired,
        content: oneOfType([func, string]).isRequired,
        shouldShowDialog: func.isRequired,
        title: string.isRequired
      }),
      disabled: bool,
      id: oneOfType([string, number]),
      label: string.isRequired,
      toolTip: string
    })),
    toolTip: string,
    type: oneOf(['content', HEADER])
  })).isRequired,
  /**
   * Minimum number of characters needed to trigger an asynchronous account search
   */
  minimumAccountSearchCharacters: number,
  /**
   * Callback fired when text is entered into the account search box. Used
   * to asynchronously search accounts. If `onAccountSearch` is provided,
   * `selectedAccount` is required. `function(searchVal: string) => void`
   */
  onAccountSearch: func,
  /**
   * Callback fired when a context is expanded. Used to asynchronously load
   * nested accounts `function(context: object) => void`
   */
  onExpandAccount: func,
  /**
   * Callback fired when product selected from product switcher
   */
  onSelectProduct: func,
  /**
   * Product selected on load
   */
  product: oneOfType([string, object]).isRequired,
  /**
   * Array of objects, each with
   *
   * - `id` string or number. Required if there is any chance the names may
   *   not be unique. Not required for dividers and headers.
   * - `name` string
   * - `disabled` bool
   * - `type` string, one of , 'DIVIDER', or 'HEADER', or undefined
   * - `nestedProducts` array of objects
   */
  products: arrayOf(shape({
    id: oneOfType([number, string]),
    name: string,
    disabled: bool,
    type: oneOfType([string, object])
  })),
  /**
   * Title attribute applied to the product switcher component
   */
  productSwitcherLabel: string,
  /**
   * Store navigation collapsed state in session storage
   */
  saveNavCollapsed: bool,
  /**
   * When missing, invalid, or not in the accounts array, the first context
   * will be selected.
   */
  selectedAccount: shape({
    name: string.isRequired,
    taxYear: string,
    type: oneOf(['production', 'test', 'default'])
  }),
  /**
   * Link defined by the application. When specified, the application must
   * manage the link selection state.
   */
  selectedLink: function selectedLink(props) {
    var initialSelectedLink = props.initialSelectedLink,
      selectedLink = props.selectedLink;
    if (selectedLink && typeof selectedLink !== 'string') {
      return new Error('selectedLink must be a string');
    }
    if (initialSelectedLink && selectedLink) {
      return new Error('initialSelectedLink and selectedLink cannot both be defined');
    }
    return null;
  },
  /**
   * Callback fired when a new context is selected
   */
  setAccount: func,
  /**
   * Display account name when there is only one account
   */
  showSingleAccount: bool
};
SovosNavigation.defaultProps = {
  accounts: undefined,
  accountsAreLoading: false,
  accountSwitcherLabels: undefined,
  className: undefined,
  'data-testid': undefined,
  didAccountChange: undefined,
  FooterProps: null,
  initialSelectedLink: undefined,
  minimumAccountSearchCharacters: undefined,
  onAccountSearch: undefined,
  onExpandAccount: undefined,
  onSelectProduct: undefined,
  products: undefined,
  productSwitcherLabel: undefined,
  saveNavCollapsed: false,
  selectedAccount: undefined,
  selectedLink: undefined,
  setAccount: undefined,
  showSingleAccount: false
};
export default SovosNavigation;